import { NgModule } from '@angular/core';
import { provideConfig } from '@spartacus/core';
import { UserAccountEventListener, UserAccountRootModule } from '@spartacus/user/account/root';
import { UserProfileRootModule } from '@spartacus/user/profile/root';
import { CustomUserAccountEventListener } from './events/custom-user-account-event.listener';

@NgModule({
  declarations: [],
  imports: [UserAccountRootModule, UserProfileRootModule],
  providers: [
    {
      provide: UserAccountEventListener,
      useClass: CustomUserAccountEventListener,
    },
    provideConfig({
      featureModules: {
        userAccount: {
          module: () =>
            import('./vsca-user-account.module').then((m) => m.VscaUserAccountModule),
        },
      },
    }),
    provideConfig({
      featureModules: {
        userProfile: {
          module: () =>
            import('@spartacus/user/profile').then((m) => m.UserProfileModule),
        },
      },
    }),
  ],
})
export class VscaUserFeatureModule  {}
